import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { enviroment } from 'src/environments/environment';

/** approval_pending: waitlist HML. Único motivo de bloqueio do shell hoje — o uso
 *  simultâneo da conta virou aviso no login, não bloqueio (ver AccountSharingAlertService). */
export type AccessBlockReason = 'approval_pending';

/**
 * Estado global de bloqueio do shell pela waitlist HML. Alimentado pelo /user/active no
 * shell e pelo interceptor (403 approval_pending).
 */
@Injectable({ providedIn: 'root' })
export class AccessBlockService {
  private readonly blockedSubject = new BehaviorSubject<AccessBlockReason | null>(null);
  readonly blocked$ = this.blockedSubject.asObservable();

  get blocked(): AccessBlockReason | null {
    return this.blockedSubject.value;
  }

  /** Resolução da waitlist. */
  setFromStatus(approvalStatus: string | null | undefined): void {
    if (!enviroment.REQUIRE_APPROVAL) return;
    const pending = approvalStatus != null && approvalStatus !== 'approved';
    this.blockedSubject.next(pending ? 'approval_pending' : null);
  }

  /** 403 approval_pending em qualquer chamada (interceptor). */
  block(): void {
    if (!enviroment.REQUIRE_APPROVAL) return;
    this.blockedSubject.next('approval_pending');
  }
}
